// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3286":"c94a4e2312478cba","7145":"edc5d04f73da5328"}[chunkId] + ".js";
};